import { Box, styled, Typography } from "@material-ui/core";
import {
  EPOCUS_TEXT_PRIMARY,
  EPOCUS_TEXT_SECONDARY,
  rem,
} from "./epocus-palette";

// A 1 or 2 holds the study from billing as non-diagnostic (PNE-908).
export const IMAGE_QUALITY_DEFINITIONS: Record<number, string> = {
  1: "No recognisable structures.",
  2: "Structures recognisable but not enough for a diagnosis.",
  3: "Enough for a diagnosis, though some views are limited.",
  4: "Every required view is diagnostic, with minor flaws.",
  5: "Every required view is clear and well optimised.",
};

const Line = styled(Typography)({
  fontSize: rem(12),
  lineHeight: 1.4,
});

export const ImageQualityDefinitions: FC<{ value: number }> = ({ value }) => (
  <Box
    component="ol"
    aria-label="What each score means"
    style={{ margin: "6px 0 0", padding: 0, listStyle: "none" }}
  >
    {[1, 2, 3, 4, 5].map((stars) => (
      <li key={stars}>
        <Line
          style={
            stars === value
              ? { color: EPOCUS_TEXT_PRIMARY, fontWeight: 700 }
              : { color: EPOCUS_TEXT_SECONDARY }
          }
        >
          {stars} {stars === 1 ? "star" : "stars"}:{" "}
          {IMAGE_QUALITY_DEFINITIONS[stars]}
        </Line>
      </li>
    ))}
  </Box>
);
